/**
 * @generated SignedSource<<c7a1269a02298214fec7ea7d2367c751>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsCityEditPageQuery$variables = {
  id: string;
};
export type SettingsCityEditPageQuery$data = {
  readonly city: {
    readonly name: string;
    readonly region: {
      readonly country: {
        readonly id: string;
        readonly name: string;
      };
      readonly id: string;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"CityEditForm_city" | "CitySidebar_city">;
  } | null;
};
export type SettingsCityEditPageQuery = {
  response: SettingsCityEditPageQuery$data;
  variables: SettingsCityEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Region",
  "kind": "LinkedField",
  "name": "region",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Country",
      "kind": "LinkedField",
      "name": "country",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsCityEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "city",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CityEditForm_city"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CitySidebar_city"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsCityEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "city",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa0a9ed629f70c03cb40e468169b850d",
    "id": null,
    "metadata": {},
    "name": "SettingsCityEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsCityEditPageQuery(\n  $id: ID!\n) {\n  city(id: $id) {\n    name\n    region {\n      id\n      name\n      country {\n        id\n        name\n      }\n    }\n    ...CityEditForm_city\n    ...CitySidebar_city\n    id\n  }\n}\n\nfragment CityEditForm_city on City {\n  id\n  name\n}\n\nfragment CitySidebar_city on City {\n  ...EntitySidebar_entity\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "671a54f2afda30c44490b2d609886956";

export default node;
